import { SVG } from '../../constants/assetLists';

export const ICONS = [
  { id: 'icon1', icon: SVG.role1Icon },
  { id: 'icon2', icon: SVG.role2Icon },
  { id: 'icon3', icon: SVG.role3Icon },
  { id: 'icon4', icon: SVG.role4Icon },
  { id: 'icon5', icon: SVG.role5Icon },
  { id: 'icon6', icon: SVG.role6Icon },
  { id: 'icon7', icon: SVG.role7Icon },
  { id: 'icon8', icon: SVG.role8Icon },
  { id: 'icon9', icon: SVG.role9Icon },
  { id: 'icon10', icon: SVG.role10Icon },
  { id: 'icon11', icon: SVG.role11Icon },
  { id: 'icon12', icon: SVG.role12Icon },
  { id: 'icon13', icon: SVG.role13Icon },
  { id: 'icon14', icon: SVG.role14Icon },
  { id: 'icon15', icon: SVG.role15Icon },
  { id: 'icon16', icon: SVG.role16Icon },
  { id: 'icon17', icon: SVG.role17Icon },
  { id: 'icon18', icon: SVG.role18Icon },
  { id: 'icon19', icon: SVG.role19Icon },
  { id: 'icon20', icon: SVG.role20Icon },
  { id: 'icon21', icon: SVG.role21Icon },
  { id: 'icon22', icon: SVG.role22Icon },
  { id: 'icon23', icon: SVG.role23Icon },
  { id: 'icon24', icon: SVG.role24Icon },
  { id: 'icon25', icon: SVG.role25Icon },
  { id: 'icon26', icon: SVG.role26Icon },
  { id: 'icon27', icon: SVG.role27Icon },
  { id: 'icon28', icon: SVG.role28Icon },
  { id: 'icon29', icon: SVG.role29Icon },
  { id: 'icon30', icon: SVG.role30Icon },
  { id: 'icon31', icon: SVG.role31Icon },
  { id: 'icon32', icon: SVG.role32Icon },
  { id: 'icon33', icon: SVG.role33Icon },
];

export const COLORS = [
  { color: '#ADE6F6' },
  { color: '#BDDDFF' },
  { color: '#E9FAFF' },
  { color: '#CBCDFF' },
  { color: '#FFE797' },
  { color: '#FFABDC' },
  { color: '#B9B9B9' },
  { color: '#E5E5E5' },
  { color: '#C4EBC1' },
  { color: '#FFCB97' },
  { color: '#C7FFEE' },
  { color: '#A7F0F3' },
];

export const ADDITIONAL_COLORS = [
  '#7DBBF0',
  '#E0A9E8',
  '#7FD87F',
  '#7FE5F0',
  '#F5B5C8',
  '#E8B84D',
  '#6CA9A9',
  '#F5A55A',
  '#A8A8A8',
  '#7FE5C8',
  '#B8A8F5',
];

export const ZONE_COLORS = [
  { color: '#7ABAFF' },
  { color: '#F09CFF' },
  { color: '#77DE6A' },
  { color: '#FFE086' },
  { color: '#FF9A27' },
  { color: '#FF9FB9' },
  { color: '#B09AFF' },
  { color: '#84CFD2' },
  { color: '#E5E5E5' },
];
